/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ValueComparingOperator {
  Equals = 'Equals',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual'
}
